/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { Suspense, lazy } from 'react';
import { cssMap, cx, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { BaseErrorBoundary } from '../ErrorBoundary/BaseErrorBoundary';

const styles = cssMap({
	wrapper: {
		marginRight: token('space.200', '16px'),
	},
	placeholder: {
		width: '64px',
		height: '84px',
	},
});

const LazyLoadedWarningIllustration = lazy(() =>
	import(/* webpackChunkName: "async-warning-illustration" */ './WarningIllustration').catch(
		(err) => {
			throw err;
		},
	),
);

const Placeholder = () => (
	<Box xcss={cx(styles.wrapper, styles.placeholder)}>
		<Box xcss={styles.placeholder} />
	</Box>
);

export default () => (
	<BaseErrorBoundary>
		<Suspense fallback={<Placeholder />}>
			<Box xcss={cx(styles.wrapper, styles.placeholder)}>
				<LazyLoadedWarningIllustration />
			</Box>
		</Suspense>
	</BaseErrorBoundary>
);
